<template>
  <div class="content">
    <div class="switchBar">
      <span v-if="iconShow" class="iconfont iconzuo1" @click="prev"></span>
        <swiper class="switch-buttons swiper-no-swiping" @clickSlide="changeActive" v-if="professionList.length > 0" :options="swiperOption" ref='mySwiper'>
          <swiper-slide v-for="(item,index) in professionList" :key="index" :class="currentProfession === item.profession_id ? 'buttons-info active' : 'buttons-info'"><p @click="changeActive(item)" :class="currentProfession === item.profession_id ? 'info-words active' : 'info-words'">{{item.level3}}</p></swiper-slide>
        </swiper>
      <span v-if="iconShow" class="iconfont iconyou1" @click="next"></span>
    </div>

    <div class="score">
      <p class="score-title">与该职位匹配度：{{reportData.match_score}}%</p>
      <p class="score-info" v-if="reportData.related_works.length > 0">
        你有 <span>{{reportData.related_works.length}}</span> 段相关工作经验,你的工作背景与职位要求 <span>高度匹配</span> ；
        你已掌握 <span>{{skillSum}}项</span> 专业技能，学习更多职业相关技能有利于提升竞争力。<br />
        若不知道如何在简历中如何体现自己的能力？查看大牛案例、咨询导师辅导都可帮你提升求职竞争力！
      </p>
      <p class="score-info" v-if="reportData.related_works.length <= 0">
        你没有与垓职类相关的工作经验，你的工作背景与职位要求 <span>相对匹配</span> ；
        你已掌握 <span>{{skillSum}}项</span> 专业技能，学习更多职业相关技能有利于提升竞争力。<br />
        若不知道如何在简历中如何体现自己的能力？查看大牛案例、咨询导师辅导都可帮你提升求职竞争力！
      </p>
    </div>

    <div class="cards">
      <div class="work_experience sameBox">
        <p class="same_title">相关经验</p>
        <div class="work_list scrollBox" v-if="reportData.related_works.length > 0">
          <div class="work_item" v-for="(item,index) in reportData.related_works" :key="index">
            <div class="company-info">
              <span>{{item.profession}}</span>
              <p>{{item.company_nick_name || item.company_name}}</p>
            </div>
            <p class="work_time">{{item.start_at ? (item.start_at.split("-")[0]+'.'+item.start_at.split("-")[1]) : ''}}{{item.start_at && item.end_at ? '-' : ''}}{{item.end_at ? (item.end_at.split("-")[0]+'.'+item.end_at.split("-")[1]) : ''}}</p>
          </div>
        </div>
        <div class="work_list scrollBox" v-else>
          <img src="https://files.wondercv.com/PC/editor/planning/company/default.png" alt="">
          <p class="company_default">暂未发现相关工作经验</p>
        </div>
      </div>
      <div class="sameBox">
        <p class="same_title">专业技能</p>
        <div class="skill_list scrollBox max-height">
          <div  v-for="(item,index) in reportData.skills" :key="index" :class="skills.me.indexOf(item) > -1 ? 'skill_item active' : 'skill_item'">
            <p>{{item}}</p>
            <span v-if="skills.me.indexOf(item) > -1" class="iconfont iconwanmei"></span>
          </div>
        </div>
      </div>
      <div class="sameBox">
        <div class="jumper_item">
          <p class="jumper_title">大牛简历案例</p>
          <span class="jumper_info">以拿到 offer 的简历分享，对照修改简历成功率翻倍</span>
          <div class="jumper_button" @click="goBigMoo">
            <p>立即查看</p>
            <span class="iconfont iconyou1"></span>
          </div>
        </div>
        <div class="line"></div>
        <div class="jumper_item">
          <p class="jumper_title">导师辅导</p>
          <span class="jumper_info">资深导师 1v1 简历优化，提升 2 倍以上面试邀约</span>
          <div class="jumper_button" @click="goTeacher">
            <p>立即查看</p>
            <span class="iconfont iconyou1"></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import api from "../../../api";
  import {swiper , swiperSlide} from 'vue-awesome-swiper'
  export default {
    name:'job-directions',
    props:{
      lev2Id:{
        type:String,
        default:""
      },
      skills:{
        type:Object,
        default:() => {
          return {}
        }
      },
      cv_token:{
        type:String,
        default:''
      }
    },
    created(){
    },
    data(){
      return {
        reportData:{
        },//职位方向数据
        professionList:[],
        swiperOption:{
          height:30,
          // slidesPerView:'auto',
          // watchSlidesProgress:true,
          // watchSlidesVisibility:true,
          // observer:true
          slidesPerView: 'auto',
          slidesPerGroup: 2,
          on:{
            tap(){
              console.log('tap')
            }
          }
        },
        currentProfession:0,
        iconShow:true,
        swiperWidth:0,
      }
    },
    components:{swiper,swiperSlide},
    async mounted(){
      await this.getDownProfessions()
      this.$refs.mySwiper.swiper.style = {}
      this.$refs.mySwiper.swiper.style.transform = 'translated3d(0px,0px,0px)'
      this.swiperWidth = this.$refs.mySwiper.swiper.wrapperEl.clientWidth
    },
    watch:{
      swiperWidth:{
        handler(val){
          val > 1048 ? this.iconShow = true : this.iconShow = false
        }
      }
    },
    computed:{
      skillSum(){
        let count = 0;
        this.skills.me.map((item) => {
          if(this.reportData.skills.find(i => i == item)){
            count ++ 
          }
        })
        return count;
      }
    },
    methods:{
      //获取level3职类
      async getDownProfessions(){
        let res = await api.planning.getJobDirections({profession_id:this.lev2Id,skills:this.skills.me,cv_token:this.cv_token})
        if(res.code === 1000){
          this.reportData = res.data
          this.professionList = res.data.profession
          this.currentProfession = res.data.profession[0].profession_id
          // this.$refs.mySwiper.swiper.style.transform = 'translated3d(0px,0px,0px)'
        }
      },
      //上一个
      prev(){
        this.$refs.mySwiper.swiper.slidePrev()
      },
      //下一个
      next(){
        this.$refs.mySwiper.swiper.slideNext()
      },
      //切换tabs
      async changeActive(data){
        // console.log(1)
        // console.log(data,'data')
        this.currentProfession = data.profession_id
        let res = await api.planning.getJobDirections({profession_id:data.profession_id.toString(),skills:this.skills.me,cv_token:this.cv_token})
        if(res.code === 1000){
          this.reportData = res.data
          // this.currentProfession = res.data.profession[0].profession_id
          // this.$refs.mySwiper.swiper.style.transform = 'translated3d(0px,0px,0px)'
        }
        this.$emit('changeProfession',data.profession_id)
      },
      goTeacher(){
        let url = process.env.NODE_ENV === 'production' ? 'https://www.wondercv.com/service/': 'https://www.wondercv.cn/service/'
        window.open(url)
      },
      goBigMoo(){
        let url = process.env.NODE_ENV === 'production' ? 'https://www.wondercv.com/jianlimoban/': 'https://www.wondercv.cn/jianlimoban/'
        window.open(url)
      }
    }
  }
</script>
<style scoped lang="scss">
.content{
  background-image: url("https://files.wondercv.com/PC/editor/planning/jobs/bgcard2.png");
  background-size: 100% 100%;
  box-sizing: border-box;
  padding: 22px 32px 32px 32px;
  margin-bottom: 50px;
  .switchBar{
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    align-items: center;
    height: 44px;
    .iconfont{
      font-size: 24px;
      color:#ededed;
      cursor: pointer;
    }
    .switch-buttons{
      display: flex;
      flex-flow: row nowrap;
      max-width: 1048px;
      overflow: hidden;
      flex: 1;
      /deep/ .swiper-wrapper{
        // display: flex;
        flex-flow: row nowrap;
        // width: 1048px;
        // overflow: hidden;
        align-items: center;
        white-space: nowrap;
        color: #fff;
        .swiper-slide {
          font-size: 18px;
          white-space: nowrap;
          // width: 200px;
          text-align: center;
          padding: 0 16px;
          display: inline-block;
          cursor: pointer;
          .info-words{
            opacity: 0.4;
          }
          .info-words:hover{
            opacity: 0.6;
          }
          .active{
            opacity: 1 !important;
          }
        }
      }
      .active{
        font-size: 24px !important;
        font-weight: 500 !important;
      }
    }
  }
  .score{
    // width: 100%;
    background:#252830;
    border-radius: 8px;
    padding: 28px 24px;
    margin-top: 18px;
    .score-title{
      font-size: 20px;
      font-weight: 600;
      color: #FFFFFF;
      line-height: 18px;
    }
    .score-info{
      color: #fff;
      font-size: 16px;
      margin-top: 16px;
      line-height: 24px;
      span{
        color: #669BFF;
      }
    }
  }
  .cards{
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    align-items: center;
    margin-top: 22px;
    .work_experience{
      .work_list{
        img{
          display: block;
          width: 74px;
          height: 74px;
          margin: 0 auto;
          margin-top: 80px;
        }
        .company_default{
          font-size: 14px;
          text-align: center;
          margin-top: 18px;
        }
        .work_item{
          display: flex;
          flex-flow: row nowrap;
          justify-content: space-between;
          align-items: flex-start;
          margin-bottom: 10px;
          box-sizing: border-box;
          background: #313744;
          padding: 20px;
          box-sizing: border-box;
          border-radius: 6px;
          .company-info{
            span{
              font-size: 16px;
              font-weight: bold;display: block;
            }
            p{
              white-space: nowrap;
              font-size: 14px;
              margin-top: 12px;
              max-width: 170px;
              overflow: hidden;
              text-overflow: ellipsis;
            }
          }
          .work_time{
            font-size: 12px;
            opacity: 0.4;
            color: #fff;
          }
        }
      }
    }
    .sameBox{
      width: 364px;
      height: 346px;
      padding: 20px 24px 12px 24px;
      border-radius: 8px;
      color: #fff;
      background: #252830;
      box-sizing: border-box;
      .same_title{
        font-size: 16px;
        text-align: center;
        margin-bottom: 20px;
      }
      .scrollBox{
        height: 284px;
        overflow-y: scroll;
      }
      .scrollBox::-webkit-scrollbar{
        display: none;
      }
    }
    .skill_list{
      display: flex;
      flex-flow: row wrap;
      justify-content: space-between;
      align-items: center;
      .skill_item{
        text-align: center;
        position: relative;
        p{
          width: 150px;
          height: 32px;
          border: 1px solid rgba(255, 255, 255, 0.3);
          border-radius: 17px;
          line-height: 34px;
          margin-bottom: 12px;
        }
        span{
          position: absolute;top: 8px;right: 10px;
        }
      }
      .active{
        p{
          background: #313744;
          border: none;
          height: 34px;
        }
      }
    }
    .jumper_item{
      padding-top: 23px;
      box-sizing: border-box;
      .jumper_title{
        font-size: 16px;
        margin-bottom: 10px;
      }
      .jumper_info{
        font-size: 13px;
      }
      .jumper_button{
        width: 143px;
        height: 38px;
        background: linear-gradient(180deg, #FF9F79 0%, #FF6644 100%);
        border-radius: 20px;
        display: flex;
        flex-flow: row nowrap;
        justify-content: center;
        align-items: center;
        margin-top: 18px;
        cursor: pointer;
        p{
          margin-right: 6px;
        }
        .iconfont{
          font-size: 17px;
        }
      }
    }
    // .jumper_button:hover{
    //   opacity: 0.8;
    // }
    .line{
      width: 316px;
      height: 1px;
      background: #FFFFFF;
      opacity: 0.08;
      margin-top: 36px;
      margin-bottom: 12px;
    }
  }
}
.max-height{
  max-height: 284px;
  height: auto !important;
}
</style>